import React, { useContext,useEffect } from "react";
import { ContextEngine } from "../engine/ContextEngine";

const StatusBar = () => {
  // 1. Get the context from your Engine
  const { context,updateContext,undo,redo } = useContext(ContextEngine);

  const session = JSON.parse(localStorage.getItem("user_session") || "{}");

  // 2. Destructure exactly what you need
  const { token, tenant_id, tenant_db, appId, userRole } = session;
  // console.log("STATUS BAR",tenant_id);
  // // Inside your Top Panel or Status Bar
  // useEffect(() => {
  //   if (!tenant_id) return;

  //   const syncTenantIcon = async () => {
  //     // Point to your new Nginx Proxy path
  //    const iconUrl = `https://static.bimzereg.com{tenant_id}/static/favicon.ico`;      
  //     try {
  //       const response = await fetch(iconUrl, { method: 'HEAD' }); // HEAD is faster, just checks if exists
  //       if (response.ok) {
  //         // 2. Push the URL to Context so Top Panel can "witness" it
  //         updateContext("view.ico", iconUrl);
  //         console.log("Tenant Icon Synced:", iconUrl);
  //       }
  //     } catch (err) {
  //       console.error("Icon sync failed:", err);
  //     }
  //   };

  //   syncTenantIcon();
  // }, [tenant_id]); // Only runs when tenantId changes


  // 2. SAFETY CHECK: If context isn't loaded yet, return null
  if (!context || !context.context_units) return null;
  const isBottomVisible = context.panelVisibility?.bottom;
  const project = context.view?.selectedProject || "No Project";
  const section = context.view?.selectedSection || "Root";
  const projectLabel = context.context_units.find(c => c.id === project)?.label || "No Project";
  const sectionLabel = context.context_units.find(c => c.id === section)?.label || "Root";


  // 3. Extract ONLY the raw data strings/numbers you need
  const units = context.context_units;

      // Calculate totals and find the first table unit
  const tableIndex = units.findIndex(u => u.type === 'table');
  const table = units[tableIndex];

  const totalRows = table?.data?.length || 0;
  const selectedRows = table?.data?.filter(item => item.meta?.selected).length || 0;

    const historyBtnStyle = (isActive) => ({
    background: '#334155',
    color: isActive ? '#f1f5f9' : '#64748b', // Dimmed if nothing to undo/redo
    border: '1px solid #475569',
    padding: '2px 10px',
    borderRadius: '4px',
    cursor: isActive ? 'pointer' : 'not-allowed',
    fontSize: '11px',
    fontWeight: 'bold',
    opacity: isActive ? 1 : 0.5,
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  });

  // 2. Aggregate counts across all table units
  // (You can also filter for a specific tableId if needed)
  const stats = units.reduce((acc, unit) => {
    if (unit.type?.toLowerCase() === "table") {
      acc.totalRows += (unit.data?.length || 0);
      acc.selectedRows += (unit.data?.filter(item => item.meta?.selected === true).length || 0);
    }
    return acc;
  }, { totalRows: 0, selectedRows: 0 });

    // ACTION: Clear all selections in one go
  const handleClearSelection = () => {
    if (!table) return;
    
    // Create new data array with selected: false for every row
    const newData = table.data.map(item => ({
      ...item,
      meta: { ...(item.meta || {}), selected: false }
    }));

    updateContext(`context_units.${tableIndex}.data`, newData);
  };

  return (
  <div className="status-bar" style={{
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'center', // 1. Vertically centers all children
    height: '32px',       // 2. Fix the height so it doesn't "grow"
    padding: '0 15px', 
    background: '#1e293b', 
    color: '#f1f5f9', 
    fontSize: '12px',
    boxSizing: 'border-box'
  }}>
    <div className="status-left" style={{ 
      display: 'flex', 
      alignItems: 'center', // 3. Centers the buttons and the path
      gap: '12px',
      height: '100%' 
    }}>
        {/* 1. NEW: CONSOLE / BOTTOM PANEL TOGGLE */}
        <button 
            onClick={() => updateContext("panelVisibility.bottom", !isBottomVisible)}
            title={isBottomVisible ? "Hide Console" : "Show Console"}
            style={{
            background: isBottomVisible ? '#3498db' : 'transparent',
            color: isBottomVisible ? '#fff' : '#94a3b8',
            border: '1px solid #475569',
            padding: '2px 8px',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '11px',
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            transition: 'all 0.2s'
            }}
        >
            <span>{isBottomVisible ? "🔽" : "🔼"}</span>
            <strong>CONSOLE</strong>
        </button>

        {/* 2. NEW: PIPELINE / FOLDER PATH */}
        <div className="pipeline-path" style={{
            display: 'flex', alignItems: 'center', gap: '6px',
            padding: '2px 10px', background: '#0f172a', borderRadius: '4px',
            border: '1px solid #334155', color: '#94a3b8', fontSize: '11px'
        }}>
            <span style={{ opacity: 0.7 }}>📁</span>
            <span style={{ color: '#38bdf8', fontWeight: 'bold' }}>{projectLabel}</span>
            <span style={{ opacity: 0.4 }}>/</span>
            <span>{sectionLabel}</span>
        </div>
        {/* HISTORY SECTION */}
        <div className="history-controls" style={{ display: 'flex', gap: '5px', borderRight: '1px solid #475569', paddingRight: '15px' }}>
          <button 
            onClick={undo} 
            title="Undo (Ctrl+Z)"
            style={historyBtnStyle(true)} // You can link this to undoStack.current.length if you export the stack
          >
            ↩️ Undo
          </button>
          <button 
            onClick={redo} 
            title="Redo (Ctrl+Y)"
            style={historyBtnStyle(true)}
          >
            ↪️ Redo
          </button>
        </div>

        <span>📊 <strong>Rows:</strong> {totalRows}</span>
        
        {/* SELECTION SUMMARY SECTION */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={{ 
            color: selectedRows > 0 ? '#38bdf8' : '#94a3b8',
            fontWeight: selectedRows > 0 ? 'bold' : 'normal',
            transition: 'all 0.2s'
          }}>
            🔘 Selected: {selectedRows}
          </span>

          {/* Conditional Clear Button */}
          {selectedRows > 0 && (
            <button 
              onClick={handleClearSelection}
              style={{
                background: '#334155', color: '#cbd5e1', border: '1px solid #475569',
                padding: '2px 8px', borderRadius: '4px', cursor: 'pointer',
                fontSize: '10px', textTransform: 'uppercase', fontWeight: 'bold',
                display: 'flex', alignItems: 'center', gap: '4px'
              }}
              onMouseEnter={(e) => e.target.style.background = '#475569'}
              onMouseLeave={(e) => e.target.style.background = '#334155'}
            >
              ✕ Clear
            </button>
          )}
        </div>
      </div>

      <div className="status-system">
        <span>Mode: <span style={{textTransform: 'uppercase'}}>{context.view.mode}</span></span>
        <span style={{ margin: '0 10px', opacity: 0.3 }}>|</span>
        <span>User: {context.user?.name || "Guest"}</span>
        <span style={{ margin: '0 10px', opacity: 0.3 }}>|</span>
        <span>Network: Online 🌐</span>
      </div>
    </div>
  );
};

export default StatusBar;
